import './blog_overview.scss';
import init_listing from 'components/listing/Listing';

function init() {
	const listing = init_listing('#blog_listing_items', {
		search_input: '#listing_filter_search',
		filters: [
			{
				el: '#listing_filter_category',
				type: 'dropdown',
				key: 'categories',
			},
			{
				el: '#listing_filter_category_buttons',
				type: 'buttons',
				key: 'categories',
				// multiple: true,
				// relation: 'and',
			},
		],
		load_more: true,
		// load_more_auto: true,
		transition_duration: 300,
		items_data: listings_data.items,
		post_count: parseInt(listings_data.post_count),
		found_posts: parseInt(listings_data.found_posts),
		query_args: listings_data.query_args,
	});
}
init();
